import { useMutation } from "@tanstack/react-query";
import axios from "axios";

import { SalesforceChatConfig } from "../types/chat";

interface GuestTokenResult {
  accessToken: string;
  expiresIn: number;
}

export function useGuestToken(config: SalesforceChatConfig) {
  return useMutation<GuestTokenResult, Error, void>({
    mutationFn: async () => {
      const url = `${config.scrtUrl}/iamessage/api/v2/authorization/unauthenticated/access-token`;

      const body = {
        orgId: config.orgId,
        esDeveloperName: config.esDeveloperName,
        deploymentName: config.deploymentName,
        capabilitiesVersion: "1",
        platform: "Web",
        context: {
          appName: "ReactChat",
          clientVersion: "1.0.0",
        },
      };

      const { data } = await axios.post(url, body, {
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
      });

      return {
        accessToken: data.accessToken,
        expiresIn: data.expiresIn,
      };
    },
  });
}
